import { z } from 'zod';
import { IAPIRecordOrder } from '../interfaces/order.interface';
import { orgaentityBase, OrgaentityNested } from '../../core-api/types/orgaentity.type';

export const ordersBatchInput = z.object({
  dryRun: z.boolean(),
  shopProductId: z.number().positive().optional(),
  orgaentityType: z.enum(['DIGITALSIGNAGE', 'SHOWROOMCONNECT', 'WELCOMEASSISTANT']),
  orgaentityIds: z.array(z.number().positive()),
  batchSize: z.number().positive(),
  batchAlreadyProcessedPaths: z.array(orgaentityBase.shape.path),
});
export type OrdersBatchInput = z.infer<typeof ordersBatchInput>;

export type OrdersBatchOutput = {
  orderCreatePayloads: Partial<IAPIRecordOrder>[];
  orderCreatePayloadsBatch: Partial<IAPIRecordOrder>[];
  allDevicesWithoutBillingNode: OrgaentityNested[];
  allDevicesWithoutLocation: OrgaentityNested[];
  allDevicesWithoutProductId: OrgaentityNested[];
  allOrdersWithIndeterminableShippingAddress: { devices: OrgaentityNested[] }[];
  /** Path to state machine name mapping. */
  stateMachineNames: Record<string, string>;
};
